import { t } from '../i18n/helpers';

export const STATUS_STYLES = {
  PENDING: { bg: 'bg-amber-500/20', text: 'text-amber-300', cal: '#d97706' },
  APPROVED: { bg: 'bg-blue-500/20', text: 'text-blue-300', cal: '#2563eb' },
  ASSIGNED: { bg: 'bg-purple-500/20', text: 'text-purple-300', cal: '#9333ea' },
  IN_PROGRESS: { bg: 'bg-teal-500/20', text: 'text-teal-300', cal: '#0d9488' },
  COMPLETED: { bg: 'bg-emerald-500/20', text: 'text-emerald-300', cal: '#059669' },
  CANCELLED: { bg: 'bg-red-500/20', text: 'text-red-300', cal: '#dc2626' },
  NO_SHOW: { bg: 'bg-zinc-500/20', text: 'text-zinc-600 dark:text-zinc-400', cal: '#71717a' },
};

export const STATUS_FLOW = ['PENDING', 'APPROVED', 'ASSIGNED', 'IN_PROGRESS', 'COMPLETED'];

export const appointmentToEvent = (a) => {
  const date = a.confirmedDate || a.preferredDate;
  const time = a.confirmedTime || a.preferredTime || '09:00';
  const start = new Date(date);
  const [h, m] = time.split(':').map(Number);
  start.setHours(h, m, 0, 0);
  const end = new Date(start);
  end.setMinutes(end.getMinutes() + (a.serviceId?.duration || 60));

  return {
    id: a._id,
    title: `${a.clientName || t('status.calendarFallback.client')} · ${a.serviceName || t('status.calendarFallback.service')}`,
    start,
    end,
    backgroundColor: STATUS_STYLES[a.status]?.cal,
    borderColor: STATUS_STYLES[a.status]?.cal,
    extendedProps: { appointment: a },
    classNames: a.status === 'CANCELLED' ? ['line-through', 'opacity-70'] : [],
  };
};
